import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white flex" }
const _hoisted_2 = { class: "flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24" }
const _hoisted_3 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-3xl font-extrabold text-gray-900" }, " Sign in to your account ", -1)
const _hoisted_5 = { class: "mt-8" }
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " Email address ", -1)
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium text-gray-700"
}, " Password ", -1)
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "remember-me",
  class: "ml-2 block text-sm text-gray-900"
}, " Remember me ", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "font-medium text-wrh-blue-400 hover:text-wrh-blue-600"
}, " Forgot your password? ", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-wrh-blue-400 hover:bg-wrh-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-wrh-blue-600 transition-colors duration-300 ease-in-out"
  }, " Sign in ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block relative w-0 flex-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute inset-0 h-full w-full object-cover",
    style: {"object-position":"75% 90%"},
    src: "/images/auth_hero_image.jpg",
    alt: "William Ryan Homes"
  })
], -1)

import { ref } from 'vue';
import Logo from '../../components/icons/Logo.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref('');
const password = ref('');
const showPasswordField = ref(true);
const persistAuth = ref(false);

const submit = async () => {
  console.log(email.value, password.value, persistAuth.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(Logo, { class: "h-16 w-auto" }),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", {
              action: "#",
              method: "POST",
              class: "space-y-6",
              onSubmit: _withModifiers(submit, ["prevent"])
            }, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    id: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (email.value = $event)),
                    name: "email",
                    type: "email",
                    autocomplete: "email",
                    required: "",
                    class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  }, null, 512), [
                    [_vModelText, email.value]
                  ])
                ])
              ]),
              (showPasswordField.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "password",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (password.value = $event)),
                        name: "password",
                        type: "password",
                        autocomplete: "current-password",
                        required: "",
                        class: "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      }, null, 512), [
                        [_vModelText, password.value]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    id: "remember-me",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (persistAuth.value = $event)),
                    name: "remember-me",
                    type: "checkbox",
                    class: "h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  }, null, 512), [
                    [_vModelCheckbox, persistAuth.value]
                  ]),
                  _hoisted_15
                ]),
                (showPasswordField.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_19
            ], 40, _hoisted_7)
          ])
        ])
      ])
    ]),
    _hoisted_20
  ]))
}
}

})